import { URLS } from "@/api/urls";
import { User } from "@/types/User";

import fetcher_v2, { ErrorMessages } from "../fetcher_v2";

type SignupBody = Pick<User, "email" | "name"> & {
  password: string;
  name: string;
  organization_name: string;
  language: string;
  turnstileToken: string;
  company_name?: string;
  full_company_name?: string;
  company_description?: string;
  onboarding_url?: string;
  use_cases?: string[];
  custom_use_case?: string;
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_term?: string;
  utm_content?: string;
};

type SignupParams = {
  validate?: boolean;
} & SignupBody;

export const signup = (body: SignupParams) => {
  return fetcher_v2<SignupBody, SignupParams, ErrorMessages<SignupBody>>(
    URLS.SIGNUP,
    {
      method: "POST",
      // UTMs captured on the landing page so the backend can forward them to
      // HubSpot on the "Onboarding - Account Created" event.
      body,
    }
  );
};
